/**
 * The JSON body of a successful response, or `undefined` when there is none.
 * @file src/web/features/admin/lib/read-json.ts
 *
 * A 204, or a 200 with nothing in it, is a success with nothing to say.
 * `res.json()` throws on both ("Unexpected end of JSON input"), which turned a
 * delete that had worked into an error on screen. Kept apart from admin-api so
 * it can be tested without a browser.
 */
export async function readJsonBody<T>(res: Pick<Response, 'status' | 'text'>): Promise<T> {
  if (res.status === 204 || res.status === 205) return undefined as T;
  const text = await res.text();
  if (!text.trim()) return undefined as T;
  return JSON.parse(text) as T;
}
